import React, { useState } from 'react';
import './AuditLogDetails.css';   
import CloseIcon from '../../../assets/svg/CloseIcon';
import AuditLogHeader from './components/AuditLogHeader';
import AuditLogRowDetail from './components/AuditLogRowDetail';
import { formatAuditDate } from '../../../utils/dateUtil';
import { capitalizeEachFirstLetter } from '../../../utils/stringUtils';

const tryParseJSON = (jsonString: string | null | undefined): any => {
    if (jsonString === null || jsonString === undefined) {
        return jsonString;
    }
    if (typeof jsonString !== 'string') {
        return jsonString;
    }
    try {
        const obj = JSON.parse(jsonString);
        if (typeof obj === 'object' && obj !== null && !Array.isArray(obj)) {
            return obj;
        }
        return jsonString;
    } catch (e) {
        return jsonString;
    }
};

const formatDisplayValue = (value: any): string => {
    if (value === null || value === undefined) {
        return '""';
    }
    if (typeof value === 'string') {
        return `"${value}"`;
    }
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }
    return String(value);
};

const AuditLogDetails = ({toggle, data}: {toggle: () => void, data: any}) => {

    const displayChange = (previousStateStr: string | null, currentStateStr: string | null): string => {
        if (previousStateStr === currentStateStr) {
            return 'No change';
        }

        const previousState = tryParseJSON(previousStateStr);
        const currentState = tryParseJSON(currentStateStr);

        const changedFields: string[] = [];

        if (typeof previousState === 'object' && previousState !== null && typeof currentState === 'object' && currentState !== null) {
            const allKeys = new Set([...Object.keys(previousState), ...Object.keys(currentState)]);
            allKeys.forEach(key => {
                const prevVal = previousState[key];
                const currVal = currentState[key];
                if (JSON.stringify(prevVal) !== JSON.stringify(currVal)) { 
                    changedFields.push(`${key}: ${formatDisplayValue(prevVal)} → ${formatDisplayValue(currVal)}`);
                }
            });
            if (changedFields.length === 0) return 'No change';
            return changedFields.join('\n');
        } else if (currentStateStr === null && typeof previousState === 'object' && previousState !== null) {
            Object.keys(previousState).forEach(key => {
                changedFields.push(`${key}: ${formatDisplayValue(previousState[key])} → ""`);
            });
            if (changedFields.length === 0 && previousStateStr !== currentStateStr) {
                 return `value: ${formatDisplayValue(previousStateStr)} → ${formatDisplayValue(currentStateStr)}`;
            }
            return changedFields.join('\n');
        } else if (previousStateStr === null && typeof currentState === 'object' && currentState !== null) {
            Object.keys(currentState).forEach(key => {
                changedFields.push(`${key}: "" → ${formatDisplayValue(currentState[key])}`);
            });
            if (changedFields.length === 0 && previousStateStr !== currentStateStr) {
                 return `value: ${formatDisplayValue(previousStateStr)} → ${formatDisplayValue(currentStateStr)}`;
            }
            return changedFields.join('\n');
        }
        return `value: ${formatDisplayValue(previousStateStr)} → ${formatDisplayValue(currentStateStr)}`;
    };
    return (
        <div className='audit-modal-background'>
            <div className='audit__container'>
                <div className='audit-content__container'>
                    <AuditLogHeader 
                        label='Details'
                        icon={ <CloseIcon /> }
                        onIconClick={toggle}
                    />
                    <table className='audit-table'>
                        <tbody>
                            <AuditLogRowDetail field='Application' description='Smart Protect Application' />
                            <AuditLogRowDetail field='Performed By' description={data.performed_by} />
                            <AuditLogRowDetail field='Performed On' description={data.performed_on} />
                            <AuditLogRowDetail field='User Type' description={capitalizeEachFirstLetter(data.user_role)} />
                            <AuditLogRowDetail field='Timestamp' description={formatAuditDate(data.created_at)} />
                            <AuditLogRowDetail field='Action' description={data.event_details} />
                            <AuditLogRowDetail field='Change' description={displayChange(data.previous_state, data.current_state)} />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AuditLogDetails;